<template>
  <b-modal ref="modal" :title="spaceplan.name" @ok="okClicked">
    <b-form-group
      id="spaceplan-name-group"
      :label="$t('vizualization-name')"
      label-for="spaceplan-name"
    >
      <b-form-input
        id="spaceplan-name"
        v-model="form.name"
        type="text"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group
      id="spaceplan-image-group"
      :label="$t('vizualization-file')"
      label-for="spaceplan-image"
    >
      <b-form-file
        id="spaceplan-image"
        v-model="form.image"
        :state="Boolean(form.image)"
        :placeholder="$t('choose-a-file')"
        :drop-placeholder="$t('drop-file-here')"
        accept="image/*"
      ></b-form-file>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'SpacePlanUpdateModalForm',
  mixins: [
    ToasterMixin,
  ],
  props: {
    spaceplan: {
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        image: null,
      },
    };
  },
  methods: {
    ...mapActions([
      'updateSpaceplan',
    ]),
    okClicked() {
      const formData = new FormData();
      if (this.form.image !== null) {
        formData.append('image', this.form.image);
      }
      formData.append('name', this.form.name);
      this.updateSpaceplan({ spaceplan: this.spaceplan, data: formData }).then(
        (resolve) => {
          this.showToast(
            `${this.$t('update-visualization')} ${this.spaceplan.name}`,
            this.$t('saved'),
            'success',
          );
          this.form.name = '';
          this.form.image = null;
        },
        (reject) => {
          this.showToast(this.$t('update-visualization'), this.$t('error'), 'danger');
        },
      );
    },
    show() {
      this.$refs.modal.show();
      this.form.name = this.spaceplan.name;
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style scoped>

</style>
